import { useEffect } from 'react';
function getScrollLeft(contentNode, scrollToIndex) {
    if (scrollToIndex === void 0) { scrollToIndex = 0; }
    // if scrollToIndex value is not valid - get the first item index
    var actualScrollToIndex = Math.max(0, Math.min(scrollToIndex, contentNode.children.length - 1));
    var scrollToChild = contentNode.children[actualScrollToIndex];
    if (!scrollToChild) {
        return null;
    }
    return Math.max(0, scrollToChild.offsetLeft -
        (contentNode.offsetWidth - scrollToChild.offsetWidth) / 2);
}
/** Handle scrolling to a particular item */
export function useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll) {
    useEffect(function () {
        requestAnimationFrame(function () {
            var contentNode = contentRef.current;
            var rootNode = rootRef.current;
            if (!contentNode || !rootNode) {
                return;
            }
            var currentScrollLeft = contentNode.scrollLeft;
            var scrollLeft = getScrollLeft(contentNode, scrollToIndex);
            if (scrollLeft !== currentScrollLeft && scrollLeft !== null) {
                if (smoothInitialScroll) {
                    contentNode.scrollLeft = scrollLeft;
                }
                else {
                    // scrollTo with a behavior parameter doesn't
                    // behave if the behavior is set in CSS...
                    contentNode.style.scrollBehavior = 'auto';
                    contentNode.scrollLeft = scrollLeft;
                    contentNode.style.scrollBehavior = 'smooth';
                }
            }
        });
    }, [contentRef, rootRef, scrollToIndex, smoothInitialScroll]);
}
//# sourceMappingURL=useSliderScrollToIndex.js.map